const appendToHead = <T extends Node>(asset: T) =>
  document.head && document.head.appendChild(asset);

export const loadAsset = ({ url }: { url: string }): Promise<void> =>
  new Promise<void>((resolve, reject) => {
    const asset = createScript({
      onError: error => reject(error),
      onLoad: () => resolve(),
      url
    });
    appendToHead(asset);
  });

const createScript = ({
  onError,
  onLoad,
  url
}: {
  url;
  onLoad?;
  onError;
}): HTMLElement => {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = url;

  if (onLoad) {
    script.addEventListener("load", onLoad, false);
  }
  if (onError) {
    script.addEventListener("error", onError, false);
  }
  return script;
};
